import { render, staticRenderFns } from "./TinyMceWrapper.vue?vue&type=template&id=d74385a4&"
import script from "./TinyMceWrapper.vue?vue&type=script&lang=js&"
export * from "./TinyMceWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports